export const filterListItems = ({
  listItems = [],
  translateString,
  search = '',
  getTranslatedListItems,
}) => {
  const translatedListItems = getTranslatedListItems
    ? getTranslatedListItems({ listItems, translateString })
    : listItems;

  return search?.length
    ? translatedListItems.filter((entity) =>
        entity.label.toLocaleLowerCase().includes(search.toLocaleLowerCase())
      )
    : translatedListItems;
};
